import "./styles.scss"

export const Section = ({className, children}) => {
  return (
    <section className={`section-container ${className ? className : ""}`}>
      {children}
    </section>
  )
}

export const SectionWrapper = ({className, children}) => {
  return (
    <>
    <div className={`section-wrapper ${className ? className : ""}`}>
      {children}
    </div>
    </>
  )
}